export const dictionary = {
  TABLES_TITLE: {
    ES: "Tus mesas",
    EN: "Your tables",
  },
  TABLE_TITLE: {
    ES: "Título",
    EN: "Title",
  },
  ADD_TABLE: {
    ES: "Agregar",
    EN: "Add new",
  },
  REMOVE_CONFIRM: {
    ES: "¿Estás seguro que deseas eliminar esta mesa? \n No podrás recuperarla.",
    EN: "Are you sure you want to delete this table? \n  You won't be able to recover it.",
  },
  TITLE_REPEATED: {
    ES: "Título repetido",
    EN: "Repeated table name."
  }
} as const;
